<template>
  <div>
    <div class="top">
      <div class="top-panels">
        <Panel
          class="top-panel"
          :panelAttr="getPanelAttr('vs-coverage-rate')"
          :panelData="getPanelData('vs-coverage-rate')"
        />
        <Panel
          class="top-panel"
          :panelAttr="getPanelAttr('user-saw-product')"
          :panelData="getPanelData('user-saw-product')"
        >
          <VsPageViews :total="getPanelData('user-saw-product').total" :withVS="getPanelData('vs-views').total" />
        </Panel>
      </div>
      <TopChartWrapper :coverageData="chartData" />
    </div>
    <ItemCoverage />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { COVERAGE_CHART_DEFINITION } from "@/misc/desktopCharts";
import Panel from "./top/Panel";
import VsPageViews from "./top/VsPageViews";
import TopChartWrapper from "./top/chart/Index";
import ItemCoverage from "./itemCoverage/Index";

export default {
  components: {
    Panel,
    VsPageViews,
    TopChartWrapper,
    ItemCoverage,
  },
  computed: {
    ...mapGetters({
      chartData: "coverage/getCoverageData",
    }),
  },
  methods: {
    getPanelAttr(name) {
      return COVERAGE_CHART_DEFINITION.find((chart) => chart.name === name);
    },
    getPanelData(name) {
      return this.chartData[name];
    },
  },
};
</script>

<style scoped lang="scss">
.top {
  border: $border-base;
  border-radius: $border-radius;
  background: $white;
}

.top-panels {
  display: flex;
}

.top-panel {
  width: 50%;

  &:first-child {
    border-right: $border-light;
  }
}
</style>
<style>
.squeezer {
  width: 137px !important;
  margin-left: 70px !important;
}
</style>
